import { FC, PropsWithChildren, ReactNode } from "react"
import { Navigate, Outlet } from "react-router-dom"
import LoadingPage from "src/LoadingPage"
import { consoleDebug } from "src/utils"

type ProtectedRouteProps = {
  isAllowed: boolean
  redirectPath?: string
  isReady?: boolean
  name?: string
  /** Rendered instead of redirect when not allowed (e.g. embedded mode error) */
  errorFallback?: ReactNode
}

export const ProtectedRoute: FC<PropsWithChildren<ProtectedRouteProps>> = ({
  isAllowed,
  redirectPath = "/login",
  isReady = true,
  children,
  name = "ProtectedRoute",
  errorFallback,
}) => {
  consoleDebug(name, { isAllowed, redirectPath, isReady })
  if (!isReady) {
    return <LoadingPage />
  }
  if (!isAllowed) {
    if (errorFallback) return <>{errorFallback}</>
    return <Navigate to={redirectPath} replace />
  }
  return children ? children : <Outlet />
}
